import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ChevronRightRounded as ChevronRightIcon } from '@mui/icons-material';
import colors from '../../assets/theme/colors';
import AskRecordAnswerText from './AskRecordAnswerText';
import AskRecordSourceList from './AskRecordSourceList';
import { AskRecordCopyAction } from './AskRecordShareActions';

const AskRecordInlineResult = ({
  answer,
  compact,
  confidence,
  onOpenSource,
  sources,
}) => (
  <Box sx={{ position: 'relative', zIndex: 1, mt: 0.9 }}>
    <AskRecordAnswerText answer={answer} compact={compact} sources={sources} />
    <AskRecordCopyAction label="Copy answer" text={answer} />
    <Box sx={{ mt: 0.65, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
      <Typography sx={{ fontSize: '0.68rem', fontWeight: 900, textTransform: 'uppercase', letterSpacing: '0.11em', color: alpha(colors.semantic.ink, 0.52) }}>
        {confidence} confidence
      </Typography>
      {sources.length ? (
        <Typography sx={{ fontSize: '0.68rem', fontWeight: 850, color: colors.brand.deep, display: 'inline-flex', alignItems: 'center', gap: 0.1 }}>
          {sources.length} source{sources.length === 1 ? '' : 's'} <ChevronRightIcon sx={{ fontSize: 14 }} />
        </Typography>
      ) : null}
    </Box>

    <AskRecordSourceList compact={compact} maxSources={compact ? 2 : 3} onOpenSource={onOpenSource} sources={sources} />
  </Box>
);

export default AskRecordInlineResult;
